import { cloneElement, isValidElement, useEffect, useRef } from "react";

export const IntersectionObserverComponent = ({
	children,
	onIntersection,
	threshold = 0.6,
}: {
	children: React.ReactElement<{ ref?: React.Ref<HTMLDivElement> }>;
	onIntersection: () => void;
	threshold?: number;
}) => {
	const ref = useRef<HTMLDivElement>(null);

	// biome-ignore lint/correctness/useExhaustiveDependencies:
	useEffect(() => {
		if (!ref.current) return;

		const observer = new IntersectionObserver(
			(entries) => {
				const [entry] = entries;
				if (entry.isIntersecting) {
					onIntersection();
					observer.disconnect();
				}
			},
			{ threshold },
		);

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, []);

	if (!isValidElement(children)) {
		return null;
	}

	return cloneElement(children, { ref });
};
